import {Contact, Customer, CustomerContact, Ref} from '@lifeislife/lifeislife-domain';
import {BehaviorSubject, Observable} from 'rxjs';


export abstract class CustomerContextService {

  availableCustomerContacts$: Observable<Ref<CustomerContact>[]>;
  activeCustomerContact$ = new BehaviorSubject<CustomerContact | null>(null);
  hasActiveCustomerContact$: Observable<boolean>;

  abstract activateCustomerContactContext(customerContactIdParam: string): void;

  abstract activateCustomerContext(customerIdParam: string): void;

  abstract selectCustomerContactRef(ref: Ref<CustomerContact>) ;

  abstract getActiveCustomerRef(): Ref<Customer> | null;

  abstract getActiveContactRef(): Ref<Contact> | null;
}
